import { render, staticRenderFns } from "./DatosCabecera.vue?vue&type=template&id=53b95b78&scoped=true"
import script from "./DatosCabecera.vue?vue&type=script&lang=js"
export * from "./DatosCabecera.vue?vue&type=script&lang=js"
import style0 from "./DatosCabecera.vue?vue&type=style&index=0&id=53b95b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b95b78",
  null
  
)

export default component.exports